<div class="bodycontent">
    <div class="subheader with-padding flgrow">
        <div class="row">

            <!-- Select Dealer -->
            <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="dealerList && dealerList.length > 0;">
                <div>
                    <label translate>
                        lblDealersName <strong class="mlt6 required"> * </strong>
                    </label>
                    <div class="relative flmid">
                        <div class="flgrow">
                            <app-dealer-searchbox-dropdown [dealerList]="dealerList" [(ngModel)]="dealerId"
                                [selectedDealer]="dealerId" ngDefaultControl name="dealerDropdown" 
                                (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer">
                            </app-dealer-searchbox-dropdown>
                        </div>
                    </div>
                </div>
                <p *ngIf="isDealerRequired" class="help-block text-danger" translate>lblRequiredDealer</p>
            </div>

            <!-- Selct Type of Report -->
            <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
                <div>
                    <label translate>
                        lblType <strong class="mlt6 required"> * </strong>
                    </label>
                    <ng-select placeholder="{{ 'lblSelectType' | translate }}" [(ngModel)]="selectedType"
                        (change)="onTypeChange($event)">
                        <ng-option *ngFor="let type of types" [value]="type.type">
                            {{ type.type }}
                        </ng-option>
                    </ng-select>
                    <p *ngIf="isTypeRequiredToShow" class="help-block text-danger" translate>lblReportRequiredType</p>
                </div>
            </div>
            
            <!-- Date Picker-->
            <!-- From Date -->
            <div class="col-2">
                <label for="template-edit-startDate" translate>lblFromDate<strong class="mlt6 required"> * </strong></label>
                <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                        required [dateTime]="false" [disableNextMonthDates]="true" [(ngModel)]="fromDate"
                        id="fromDate" name="fromDate" type="text" value="{{this.fromDate}}" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                </div>
            </div>
            <!-- To Date -->
            <div class="col-2">
                <label for="template-edit-endDate" translate>lblToDate<strong class="mlt6 required"> * </strong></label>
                <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                        required [dateTime]="false" [disableNextMonthDates]="true" [(ngModel)]="toDate" id="toDate"
                        name="toDate" type="text" value="{{this.toDate}}" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                </div>
            </div>

            <!-- Select Mechnic -->
            <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
                <div>
                    <label translate>lblMechanicTitle</label>
                    <div class="relative flmid">
                        <div class="flgrow">
                            <ng-select class="" placeholder="{{ 'lblSelectMechanic' | translate }}"
                                (change)="selectedMechanic($event)" [(ngModel)]="mechanicId" style="max-width: 250px;">

                                <ng-option *ngFor="let mechanic of mechanicList" [(value)]="mechanic.id">
                                    <span [title]="mechanic.name">{{ mechanic.name }}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Search -->
            <button type="button" (click)="onSearchReport()" class="btn btn-primary btn">
                <em class="fa fa-search"></em>
            </button>

            <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" *ngIf="!isMechanicAccuracyScreen">
                <!-- Excel -->
                <button type="button" (click)="exportAsXLSX(documentTypes.Excel)" 
                    ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align" style="margin-right: 10px; margin-top: 1.1rem;">
                    <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
                </button>
                <!-- PDF -->
                <button class="btn btn-link icon-pdf" type="button" (click)="onDownloadPDF(documentTypes.Pdf)" style="margin-top: -0.4rem;"
                    ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
                    <em class="far fa-file fa-2x"></em>
                    <span class="bdg">PDF</span>
                </button>
            </div>

            <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" *ngIf="isMechanicAccuracyScreen">
                <!-- Excel -->
                <button type="button" (click)="exportAccuracyAsXLSX()" 
                    ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align" style="margin-right: 10px; margin-top: 1.1rem;">
                    <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
                </button>
                <!-- PDF -->
                <button class="btn btn-link icon-pdf" type="button" (click)="exportAccuracyAsPDF()" style="margin-top: -0.4rem;"
                    ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
                    <em class="far fa-file fa-2x"></em>
                    <span class="bdg">PDF</span>
                </button>
            </div>

        </div>
    </div>
</div>
<div class="card m-2 scrollbar" *ngIf="!isMechanicAccuracyScreen">
    <div class="table-responsive" infinite-scroll [scrollWindow]="false" *ngIf="showData">

        <!-- Report of type "Summary" -->
        <ng-container *ngIf="isSummaryTypeSelected && showData; else detail_Type_Report_Selected">
            <table style="width:100%" class="table table-bordered fixed-column mb-0" aria-describedby="mechanicefficiencysummaryreport">
                <tr>
                    <td style="width: 200px;">
                        {{ 'lblMechanicName' | translate}}
                    </td>
                    <td>
                        {{ 'lblMechanicNumber' | translate}}
                    </td>
                    <th *ngFor="let month of months"  style="text-align: center;border-right-color: #494751;" scope="colgroup" [attr.colspan]="detailReportTitle.length">
                        {{month | date: 'MMMM-yyyy':'':'en-US' }}
                    </th>
                </tr>
                <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <ng-container *ngFor="let month of months">
                        <ng-container *ngFor="let title of detailReportTitle">
                            <th scope="col" [ngStyle]="title == 'lblAvgHourlyRateExclVat' && {'border-right-color': '#494751'}">
                                {{ title | translate }}
                                <button class="info-btn" [ngbTooltip]="getColumnInfo(title)" placement="left" triggers="hover">
                                    <em class="fas fa-info-circle text-info"></em>
                                </button>
                            </th>
                        </ng-container>
                    </ng-container>
                </tr>
                <ng-template ngFor let-mechanic [ngForOf]="mechanicsData" let-i="index">
                    <tr>
                        <th>
                            {{mechanic.mechanicName}}
                        </th>
                         <td>
                            {{mechanic.mechanicNo}}
                         </td>
                        <ng-template ngFor let-month [ngForOf]="months">
                            <ng-container *ngFor="let mec of mechanic.mechanicsDetails">
                                <ng-container *ngIf="mec.month === month">
                                    <td style="text-align:right;">
                                        {{ mec.totalInvoiceHours }}
                                    </td>
                                    <td style="text-align:right;">
                                        {{mec.totalInvoiceAmount | number: '1.2-2'}}
                                    </td>
                                    <td style="text-align:right;">
                                        {{ mec.totalPlannedHours }}
                                    </td>
                                    <td style="text-align:right;">
                                        {{ mec.totalClockHours }}
                                    </td>
                                    <td style="text-align:right;">
                                        {{ mec.totalStampInHours }}
                                    </td>
                                    <td class="efficiency-hightlight">
                                        {{mec.productivity | number: '1.2-2'}}%
                                    </td>
                                    <td class="efficiency-hightlight">
                                        {{mec.efficiency | number: '1.2-2'}}%
                                    </td>
                                    <td class="efficiency-hightlight" style="border-right-color: #494751;">
                                        {{mec.avgHourlyRate | number: '1.2-2'}}
                                    </td>
                                </ng-container>
                            </ng-container>
                        </ng-template>
                    </tr>
                </ng-template>
            </table>
        </ng-container>

        <!-- Report of type "Detail" -->
        <ng-template #detail_Type_Report_Selected>
            <table class="table table-bordered fixed-column mb-0" aria-describedby="mechanicefficiencydetailreport">
                <tr>
                    <td style="width: 200px;">
                        {{ 'lblMechanicName' | translate}}
                    </td>
                     <td >
                        {{ 'lblMechanicNumber' | translate}}
                     </td>
                    <th style="text-align: center;border-right-color: #494751;" scope="colgroup" [attr.colspan]="detailReportTitle.length"
                        *ngFor="let date of dates">
                        {{ date | date:'dd.MM.yyyy'}}
                    </th>
                </tr>
                <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <ng-container *ngFor="let dt of dates">
                        <ng-container *ngFor="let title of detailReportTitle">
                            <th scope="col" [ngStyle]="title == 'lblAvgHourlyRateExclVat' && {'border-right-color': '#494751'}">
                                {{ title | translate }}
                                <button class="info-btn" [ngbTooltip]="getColumnInfo(title)" placement="left" triggers="hover">
                                    <em class="fas fa-info-circle text-info"></em>
                                </button>
                            </th>
                        </ng-container>
                    </ng-container>
                </tr>

                <ng-container *ngFor="let mechanic of mechanicsData; let i = index">
                    <tr>
                        <th id="i">
                            {{ mechanic.mechanicName }}
                        </th>
                        <td>
                            {{mechanic.mechanicNo}}
                        </td>
                        <ng-container *ngFor="let d of dates">
                            <ng-container *ngFor="let mec of mechanic.mechanicsDetails">
                                <ng-container *ngIf="mec.month === d">
                                    <td style="text-align:right;">
                                        {{ mec.totalInvoiceHours }}
                                    </td>
                                    <td style="text-align:right;">
                                        {{mec.totalInvoiceAmount | number: '1.2-2'}}
                                    </td>
                                    <td style="text-align:right;">
                                        {{ mec.totalPlannedHours }}
                                    </td>
                                    <td style="text-align:right;">
                                        {{ mec.totalClockHours }}
                                    </td>
                                    <td style="text-align:right;">
                                        {{ mec.totalStampInHours }}
                                    </td>
                                    <td class="efficiency-hightlight">
                                        {{mec.productivity | number: '1.2-2'}}%
                                    </td>
                                    <td class="efficiency-hightlight">
                                        {{mec.efficiency | number: '1.2-2'}}%
                                    </td>
                                    <td class="efficiency-hightlight" style="border-right-color: #494751;">
                                        {{mec.avgHourlyRate | number: '1.2-2'}}
                                    </td>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </tr>
                </ng-container>
            </table>
        </ng-template>

    </div>
</div>

<table id="MechanicEfficiencyPDFdata" style="display: none;">
    <thead>
        <tr >
            <th>Number</th>
            <th>{{ 'lblDate' | translate }}</th>
            <th>{{ 'lblMechanicName' | translate }}</th>
            <th>{{ 'lblMechanicNumber' | translate }}</th>
            <th>{{ 'lblInvoiceHours' | translate }}</th>
            <th>{{ 'lblInvoiceAmountExclVAT' | translate }}</th>
            <th>{{ 'lblPlannedHours' | translate }}</th>
            <th>{{ 'lblClockedHours' | translate }}</th>
            <th>{{ 'lblPatternedHours' | translate }}</th>
            <th>{{ 'lblProductivityTitle' | translate }}</th>
            <th>{{ 'lblEfficiencyTitle' | translate }}</th>
            <th>{{ 'lblAvgHourlyRateExclVat' | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of mechanicEfficiencyListPDF" >
            <td >{{item.rowNumber}}</td>
            <td>{{ isSummaryTypeSelected ?(item.date | date:'MMMM-yyyy':'':'en-US') :(item.date | date:'dd.MM.yyyy':'':'en-US')  }}</td>
            <td>{{item.mechanicName}}</td>
            <td>{{item.mechanicNo}}</td>
            <td >{{item.totalInvoiceHours}}</td>
            <td>{{item.totalInvoiceAmount}}</td>
            <td>{{item.totalPlannedHours}}</td>
            <td>{{item.totalClockHours}}</td>
            <td>{{item.totalStampInHours}}</td>
            <td>{{item.productivity}}</td>
            <td>{{item.efficiency}}</td>
            <td>{{item.avgHourlyRate}}</td>
        </tr>
    </tbody>
</table>

<div class="card m-2 scrollbar" *ngIf="isMechanicAccuracyScreen">

    <div class="table-responsive" infinite-scroll [scrollWindow]="false" *ngIf="showData">
        <!-- Report of type "Summary" -->
        <ng-container *ngIf="isSummaryTypeSelected && showData; else detail_Type_Report_SelectedAccuracy">
            <table style="width:100%" class="table table-bordered fixed-column mb-0" aria-describedby="mechanicaccuracysummaryreport">
                <tr>
                    <td style="width: 200px;">
                        {{ 'lblMechanicName' | translate}}
                    </td>
                     <td style="width: 120px;">
                        {{ 'lblMechanicNumber' | translate}}
                     </td>
                    <th *ngFor="let month of months" scope="col">
                        {{month | date: 'MMMM-yyyy':'':'en-US' }}
                    </th>
                </tr>

                <ng-container  *ngFor="let mechanic of accuracyMechanicsData" >
                    <tr>
                        <th>
                            {{mechanic.mechanicName}}
                        </th>
                        <td>
                            {{mechanic.mechanicNo}}
                         </td>
                        <ng-container *ngFor="let month of months" >
                            <ng-container *ngFor="let m of mechanic.mechanicsDetails">
                                <td *ngIf="m.months === month">
                                    {{m.accuracy}}
                                </td>
                            </ng-container>
                        </ng-container>
                    </tr>
                </ng-container>
            </table>
        </ng-container>

        <!-- Report of type "Detail" -->
        <ng-template #detail_Type_Report_SelectedAccuracy>
            <table class="table table-bordered fixed-column mb-0" aria-describedby="mechanicaccuracydetailreport">
                <tr>
                    <td style="width: 200px;">
                        {{ 'lblMechanicName' | translate}}
                    </td>
                     <td style="width: 120px;">
                        {{ 'lblMechanicNumber' | translate}}
                     </td>
                    <th style="text-align: center" scope="colgroup" [attr.colspan]="detailReportTitleAccuracy.length"
                        *ngFor="let date of dates">
                        {{ date | date:'dd.MM.yyyy'}}
                    </th>
                </tr>
                <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <ng-container *ngFor="let dt of dates">
                        <ng-container *ngFor="let title of detailReportTitleAccuracy">
                            <th scope="col">
                                {{ title | translate }}
                            </th>
                        </ng-container>
                    </ng-container>
                </tr>
                <ng-container *ngFor="let mechanic of accuracyMechanicsData; let i = index">
                    <tr>
                        <th id="i">
                            {{ mechanic.mechanicName }}
                        </th>
                        <td>
                            {{mechanic.mechanicNo}}
                         </td>
                        <ng-container *ngFor="let d of dates">
                            <ng-container *ngFor="let mec of mechanic.mechanicsDetails">
                                <ng-container *ngIf="mec.months === d">
                                    <td style="text-align: right;">
                                        {{ mec.totalWorkingHourString }}
                                    </td>
                                    <td style="text-align: right;">
                                        {{ mec.totalPlannedHourString }}
                                    </td>
                                    <td style="text-align: right;">
                                        {{ mec.totalUnPlannedHourString }}
                                    </td>
                                    <td style="text-align: right;">
                                        {{ mec.accuracy }}
                                    </td>
                                    
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </tr>
                </ng-container>
            </table>
        </ng-template>

    </div>
</div>